<template>
  <section>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-title>Ajout d'un juzz</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="nameJuzz"
                    label="Nom"
                    outlined
                    :rules="rule"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-select
                    v-model="suratName"
                    label="Nom du Surate (Français)"
                    :items="suratArray"
                    :rules="rule"
                    item-text="frenchName"
                    item-value="frenchName"
                    required
                    outlined
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-select
                    v-model="premierSurateNameEn"
                    label="Nom du Surate (Anglais)"
                    :items="suratArray"
                    :rules="rule"
                    item-text="englishName"
                    item-value="englishName"
                    required
                    outlined
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="3">
                  <v-text-field
                    v-model="rangJuzz"
                    outlined
                    label="Rang"
                    :rules="rule"
                  />
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="numVerset"
                    hide-details
                    outlined
                    type="number"
                    oninput="if(this.value < 1) this.value = 1;"
                    label="Numero verset"
                    :rules="rule"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn
                      class="ml-6 mt-4"
                      color="info"
                      @click="validate"
                      :loading="loadingAddJuz"
                    >
                      Enregistrer
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="mb-6 ml-6 mt-6 mr-2">
      <v-card-title>Liste des juzs</v-card-title>
      <v-text-field
        style="padding: 15px"
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        clearable
        :search="search"
      ></v-text-field>
      <v-data-table
        :search="search"
        :loading="isLoadingTables"
        loading-text="Loading..."
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 30],
        }"
        :headers="headers"
        :items="juzzArray"
        class="elevation-1"
      >
        <template v-slot:[`item.modifier`]="{ item }">
          <v-icon @click="updateClickIcon(item)">
            {{ icons.mdiPencil }}
          </v-icon>
        </template>
        <template v-slot:[`item.supprimer`]="{ item }">
          <v-icon @click="suppressionAction(item.juzId)">
            {{ icons.mdiDeleteOutline }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogAddJuz" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir ajouter le juz ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="reinitialisationFormulaire()"
            >
              Annuler
            </v-btn>

            <v-btn
              color="info darken-1 "
              text
              @click="ajoutJuz()"
              :loading="loadingAddJuz"
            >
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogEditJuz" persistent max-width="800px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Informations juz</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="juzz.name"
                        label="Nom"
                        outlined
                        :rules="rule"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="juzz.premierSurateName"
                        label="Nom du Surate (Français)"
                        :items="suratArray"
                        :rules="rule"
                        item-text="frenchName"
                        item-value="frenchName"
                        required
                        outlined
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="juzz.premierSurateNameEn"
                        label="Nom du Surate (Anglais)"
                        :items="suratArray"
                        :rules="rule"
                        item-text="englishName"
                        item-value="englishName"
                        required
                        outlined
                      />
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="juzz.rank"
                        outlined
                        label="Rang"
                        :rules="rule"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="juzz.premierVersetNumero"
                        hide-details
                        outlined
                        type="number"
                        oninput="if(this.value < 1) this.value = 1;"
                        label="Numero verset"
                        :rules="rule"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogEditJuz = false">
                Annuler
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="validateChampEdit()"
                :loading="loadingEditJuz"
              >
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-row justify="center">
      <v-dialog v-model="dialogDeleteJuzz" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir supprimer le juz ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="dialogDeleteJuzz = false"
            >
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="deleteJuzz()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogConfirmEditJuz" max-width="650">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir mettre à jour les informations du juz ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="dialogConfirmEditJuz = false"
            >
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="updateJuzz()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </section>
</template>
<script>
import { mdiPlus, mdiDeleteOutline, mdiPencil } from "@mdi/js";
import Constant from "@/utils/constants";
import { getAllSurat, getAllJuzz } from "@/views/qorani/services/services";
export default {
  data() {
    return {
      search: "",
      icons: {
        mdiPlus,
        mdiDeleteOutline,
        mdiPencil,
      },
      suratArray: [],
      valid: true,
      rule: [(v) => !!v || "Ce champ est requis"],
      nameJuzz: "",
      suratName: "",
      premierSurateNameEn: "",
      rangJuzz: "",
      numVerset: "",
      juzz: {
        name: "",
        premierSurateName: "",
        premierSurateNameEn: "",
        rank: null,
        premierVersetNumero: null,
      },
      loadingAddJuz: false,
      dialogAddJuz: false,
      juzzArray: [],
      isLoadingTables: false,
      headers: [
        { text: "Nom", value: "name", align: "center" },
        { text: "Nome surat", value: "premierSurateName", align: "center" },
        { text: "Nom surat en englais", value: "premierSurateNameEn", align: "center" },
        {
          text: "Numero verset",
          value: "premierVersetNumero",
          align: "center",
        },
        { text: "Rang", value: "rank", align: "center" },
        { text: "Modifier", value: "modifier", align: "center" },
        { text: "Suppression", value: "supprimer", align: "center" },
      ],
      dialogDeleteJuzz: false,
      dialogEditJuz: false,
      loadingEditJuz: false,
      dialogConfirmEditJuz: false,
    };
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        // this.dialogAddJuz = true;
        this.ajoutJuz();
      }
    },
    reinitialisationFormulaire() {
      this.dialogAddJuz = false;
      this.$refs.form.reset();
    },
    async ajoutJuz() {
      this.loadingAddJuz = true;
      this.juzz.name = this.nameJuzz;
      this.juzz.premierSurateName = this.suratName;
      this.juzz.premierSurateNameEn = this.premierSurateNameEn;
      this.juzz.premierVersetNumero = Number(this.numVerset);
      this.juzz.rank = Number(this.rangJuzz);

      const responseCategorie = await fetch(Constant.QORANI + "juz/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.juzz),
      });

      try {
        this.loadingAddJuz = false;
        this.dialogAddJuz = false;
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de l'ajout du juz, veuillez réessayez plus tard, Merci."
        );
        this.loadingAddJuz = false;
        this.dialogAddJuz = false;
      }
    },
    suppressionAction(item) {
      this.idJuzzSupprimmer = item;
      // this.dialogDeleteJuzz = true;
      this.deleteJuzz();
    },
    async deleteJuzz() {
      const responseCategorie = await fetch(
        Constant.QORANI + `juz/delete/${this.idJuzzSupprimmer}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      try {
        this.dialogDeleteJuzz = false;
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de la suppression du juz, veuillez réessayez plus tard, Merci."
        );
        this.dialogDeleteJuzz = false;
      }
    },
    updateClickIcon(item) {
      this.dialogEditJuz = true;
      this.juzz = item;
      this.idjuzz = item.juzId;
    },
    validateChampEdit() {
      if (this.$refs.form.validate()) {
        // this.dialogConfirmEditJuz = true;
        this.updateJuzz();
      }
    },
    async updateJuzz() {
      this.loadingEditJuz = true;
      this.juzz.premierVersetNumero = Number(this.juzz.premierVersetNumero);
      this.juzz.rank = Number(this.juzz.rank);
      const responseCategorie = await fetch(
        Constant.QORANI + `juz/edit/${this.idjuzz}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.juzz),
        }
      );

      try {
        this.loadingEditJuz = false;
        this.dialogConfirmEditJuz = false;
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de la mise à jour du juz, veuillez réessayez plus tard, Merci."
        );
        this.loadingEditJuz = false;
        this.dialogConfirmEditJuz = false;
      }
    },
  },
  async created() {
    this.isLoadingTables = true;
    this.suratArray = await getAllSurat();
    this.juzzArray = await getAllJuzz();
    this.isLoadingTables = false;
  },
};
</script>
